import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { defaultFattyAcidSets } from './defaultFattyAcidSets';
import { FattyAcidSelector } from './FattyAcidSelector';
import { useFattyAcids } from './useFattyAcids';


export const FattyAcidSetSelector = ({ fattyAcids, setFattyAcids }) => {
  const options = defaultFattyAcidSets.map((set) => ({
          value: set.id,
          label: set.name,
          fattyAcids: set.fattyAcids
  }));


  return (
    <div className="mb-3 card card-body">
      <label className="form-label" htmlFor="fattyAcidSetSelector">
        Fatty acid set to use during optimization
      </label>
      <Select
        isSearchable
        isClearable
        options={options}
        onChange={set => set ? setFattyAcids(set.fattyAcids) : setFattyAcids([])}
      />
      <FattyAcidSelector
        selectedCells={fattyAcids}
        setSelectedCells={setFattyAcids}
      />
    </div>
  )
}
